import styled, { css } from 'styled-components';
import { infiniteRotationAnimation } from 'styles/animations';
import { BREAKPOINTS } from 'styles/media';

export const PeopleSideBarSearchWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PeopleSideBarSearchTitle = styled.h6`
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  color: var(--color-text);
`;

export const PeopleSideBarSearchContentContainer = styled.div`
  position: relative;
`;

export const PeopleSideBarSearchContainer = styled.div`
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 16px;

  border-radius: 26px;
  background: #ffffff;

  box-shadow: 0px 6px 24px 0px rgba(0, 0, 0, 0.1);

  position: relative;
  z-index: 5;
`;

export const PeopleSideBarSearchIconsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  gap: 4px;
`;

export const PeopleSideBarSearchClearIconContainer = styled.div`
  width: 18px;
  height: 18px;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
`;

export const PeopleSideBarSearchInput = styled.input`
  flex: 1;

  font-weight: 500;
  font-size: 14px;
  line-height: normal;

  color: var(--color-text);

  border: none;
  outline: none;
  background: transparent;

  &::placeholder {
    color: rgba(23, 28, 51, 0.5);
  }
`;

export const PeopleSidebarSearchContentWrapper = styled.div`
  min-width: 322px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  padding: 68px 0px 16px 0px;

  ${BREAKPOINTS.tablet} {
    min-width: unset;
  }

  border-radius: 24px;
  background: #fff;
  box-shadow: 2px 2px 15px -4px rgba(16, 77, 91, 0.25);
`;

export const PeopleSidebarSearchContentList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const PeopleSidebarSearchContentItemName = styled.span`
  max-width: 60%;

  font-weight: 500;
  font-size: 16px;
  line-height: normal;

  color: #000;
`;

export const PeopleSidebarSearchNoMatches = styled.span`
  width: 100%;

  font-weight: 400;
  font-size: 14px;
  line-height: normal;
  text-align: center;

  color: #000;
`;

export const PeopleSidebarSearchContentItemContainer = styled.div`
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 3px 24px 3px 16px;

  & > ${PeopleSidebarSearchContentItemName} > span.highlighted {
    font-weight: 700;
  }

  cursor: pointer;
`;

export const PeopleSidebarSearchContentItemRightContainer = styled.div`
  width: fit-content;

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  max-width: 40%;
`;

export const PeopleSidebarSearchContentItemCompany = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: normal;
  text-align: right;

  color: var(--color-data-alumni-background);
`;

export const PeopleSidebarSearchContentLoadingContainer = styled.div`
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  & > .spinner-icon {
    ${infiniteRotationAnimation('5s', 'ease')}
  }
`;
